import React from "react";
import Footer from "../../app/Layout/Public/Footer";

const LoginFooter = () => <Footer />;

export default LoginFooter;
